import { render } from "./IconStats.vue?vue&type=template&id=75dd1688"
import script from "./IconStats.vue?vue&type=script&lang=js"
export * from "./IconStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__